import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inSchoolCartService } from './InSchoolCart/InSchoolCart.service';

const CartService = inSchoolCartService;


export class SearchSchoolBookBtn extends Component {

  /**
     * This component has three possible states
     * book | processing | cart
     * @param props
     */
  constructor(props) {
    super(props);

    this.state = {
      status: props.status,
    };
  }

  /**
     * Display the popup telling the customer to call the frontoffice
     */
  _displayError() {
    $('#bookingError').modal('show');
  }

  /**
     * Redirect the user to the cart
     */
  /* istanbul ignore next */
  _redirectTo() {
    //window.location = location.origin + location.pathname + 'order';
    window.location = location.origin + '/winkelwagen';
  }


  /**
     * Perform action depending on the button state
     */
  _onClickButton() {
    const { training } = this.props;
    let { status } = this.state;

    if (training.order_type === 'contact') {
      this._displayError();
    } else if (status === 'book') {
      this._addTraining();
    } else if (status === 'cart') {
      this._redirectTo();
    }
  }

  /**
     * Store the training in the localstorage
     * and store the training_id in the php session
     */
  _addTraining() {
    this.setState({ status: 'processing' });
    const { training } = this.props;
    CartService.addTraining(training.id_training);
  }

  render() {
    const { status } = this.state;

    const icon = (<span className="search-results__item-table-button-icon">
      <i className="fa fa-cart-arrow-down" aria-hidden="true"/>
    </span>);

    return (
      <button className="school-page__book-btn"
        onClick={() => this._onClickButton()}>
        {status === 'book' && icon}
        {status === 'processing' && 'Bezig...'}
        {status === 'cart' && 'Afrekenen'}
      </button>
    );
  }
}

SearchSchoolBookBtn.propTypes = {
  training: PropTypes.object,
  status: PropTypes.string,
};
